// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
    //TODO: write your page related code here...
});

export function whiteglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "white";
}

export function originalglasses_click(event) {
    $w('#bgbox').style.backgroundColor = "#dce6f2";
}


export function lightblueglasse_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#9ab8fc";
}

export function lightgreenglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#a6f8e3";
}

export function greenglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#aaf2a0";	
}

export function yellowglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#ffff8f";
}

export function lightyellowglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#ffde75"; 
}

export function pinkglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#bf95df";
}

export function creamglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#fcd5b5";
}

export function darkcreamglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#e3b0af";
}

export function lightgrayglasses_click(event) {
	//Add your code for this event here: 
    $w('#bgbox').style.backgroundColor = "#d9d9d9"
}